<style >
.mybox {
  background-color: #f6d4d8; /* 背景色 */
  border-radius: 5px;
  margin: 20px 5px; /* 外側の余白 上下・左右 */
  padding: 30px 20px 20px 20px; /* 内側の余白 上・右・下・左 */
  position: relative;
  z-index: 0;
  font-size: 17px;
  line-height: 1.7em;
}
.btnripple2 {
  position: relative;
  display: inline-block;
  background: #333;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  color: #ccc;
  outline: none;
  transition: all 0.3s;
}
.btnripple2:hover {
  background: #666;
}
.btnripple2::after,
.btnripple2::before {
  content: "";
  position: absolute;
  left: -25%;
  top: -25%;
  border: 1px solid #333;
}
.mybox:before {
  border: 1px solid #fff; /* 白い実線 */
  border-radius: 5px;
  content: "";
  display: block;
  margin: 4px;
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  z-index: -1;
}
.mybox:after {
  background-color: rgba(249, 223, 213, 0.9); /* マステ背景色 */
  background-image: radial-gradient(#fff 20%, transparent 0),
    radial-gradient(#fff 20%, transparent 0); /* 水玉の色 */
  background-position: 0 0, 8px 8px; /* 水玉の距離 */
  background-size: 15px 15px; /* 水玉の大きさ */
  border-left: 2px dotted rgba(0, 0, 0, 0.1);
  border-right: 2px dotted rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  content: "このSTEPでやること";
  display: block;
  padding: 5px 20px;
  text-align: center;
  position: absolute;
  top: -10px;
  left: 20px;
  transform: rotate(-3deg);
  -moz-transform: rotate(-3deg);
  -webkit-transform: rotate(-3deg);
  -o-transform: rotate(-3deg);
}
</style>

<template>
  <v-container>
    <v-card>
      <v-toolbar color="green" dark flat src="../assets/rect.png">
        <v-toolbar-title href="">FFXIV地図主催ツール 7.0対応版(β版)</v-toolbar-title>
        <template v-slot:extension>
          <v-tabs v-model="tabs" centered>
            <v-tab>STEP0:PT募集文作成</v-tab>
            <v-tab>STEP1:座標の書き込みから経路マクロ生成</v-tab>
            <v-tab v-on:click="firstclickstep2()">STEP2:経路を見て確認</v-tab>
          </v-tabs>
        </template>
      </v-toolbar>

      <v-tabs-items v-model="tabs">
        <v-tab-item>
          <v-card flat>
            <v-card-title>
              <p class="mybox">
                PT募集用の文章を生成します。スキップして上部STEP1をクリックしてルート生成をすることができます。
                <br />
                それぞれの項目を設定したら、一番下のコピーを押して、PT募集文に貼ってください。
                <br />
                専用の項目を追加したい方は、編集ボタンで直接編集してください。
                サーバー以外、デフォルトで入っている値がよくある募集です。データセンターの文化や用途によってカスタマイズしてください！
              </p>
            </v-card-title>
            <v-card-text>
              <v-select
                v-model="use_maptype"
                :items="maptype"
                label="地図の種類(7.0対応済み)"
              ></v-select>
              <v-select
                v-model="use_server"
                :items="servers"
                label="サーバー"
              ></v-select>
              <v-select
                v-model="use_rottype"
                :items="rottype"
                label="ロット"
              ></v-select>
              <v-select
                v-model="use_mapowner"
                :items="mapowner"
                label="地図の持ち寄り"
              ></v-select>
              <v-select
                v-model="use_teleportowner"
                :items="teleportowner"
                label="テレポ主"
              ></v-select>
              <v-container class="px-0" fluid>
                <v-checkbox
                  v-model="use_checkbox"
                  :label="`【ルール】：PT参加後座標をチャットに発言`"
                ></v-checkbox>
                <v-checkbox
                  v-model="use_checkbox2"
                  :label="`【ルール】：PT参加前に募集ワールドへ移動(モブハンPTが募集ワールドに集中すると入れなくなる対策)`"
                ></v-checkbox>
                <v-card elevation="3">
                  <v-card-text>
                    <v-btn
                      class="ma-2"
                      color="indigo"
                      dark
                      @click="copyToClipboard1('a')"
                    >
                      <v-icon>mdi-content-copy</v-icon>
                      <span v-if="this.editmessage == ''">コピー</span>
                      <span v-if="this.editmessage != ''">原文をコピー</span>
                    </v-btn>
                    <v-btn class="ma-2" color="indigo" dark @click="edit1()">
                      <v-icon>mdi-pencil</v-icon>編集
                    </v-btn>

                    <span ref="message">
                      宝の地図:<span v-if="use_maptype.length > 0">{{
                        use_maptype
                      }}</span
                      >/募集ワールド:<span v-if="use_server.length > 0">{{
                        use_server
                      }}</span
                      >/ロット:<span v-if="use_rottype.length > 0"
                        >{{ use_rottype }}/</span
                      ><span v-if="use_mapowner.length > 0">{{
                        use_mapowner
                      }}</span
                      >/テレポ:{{ use_teleportowner
                      }}<span v-if="use_checkbox == true"
                        >/PT参加後座標をチャットに書き込んでください</span
                      >
                      <span v-if="use_checkbox2 == true"
                        >/PT参加前に募集ワールド移動</span
                      >
                    </span>
                    <v-divider></v-divider>
                    <v-textarea
                      :value="this.editmessage"
                      v-if="this.editmessage != ''"
                    ></v-textarea>
                  </v-card-text>
                  <div></div>
                </v-card>
              </v-container>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-card-title class="text-h5">
              <p class="mybox">
                座標の書き込みをPT人数分、左の入力欄にペーストしてください。
                <span>
                  <v-btn v-on:click="sampledatainput"
                    >お試しで仮のデータを入力してみる</v-btn
                  >
                </span>
                <br />
                例：<span style="font-weight: bold"
                  >&lt;XIV Charactor&gt; サベネア島 ( 21.3 , 28.6 )
                </span>
                <br />
                その後、経路作成ボタンを押すと、右側に経路のマクロが出ますので、ゲーム内マクロに貼り付けて発言してください。
                <br />
                また下部には、全員揃った後に発言するための再集合用のマクロがあります。準備が整ったらSTEP2へ進みます。
                <br />
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header
                      style="background-color: lightpink"
                    >
                      その他の注意事項
                    </v-expansion-panel-header>

                    <v-expansion-panel-content>
                      <span style="font-size: 14px">
                        ＊なぜ再集合するかは、「宝の地図
                        組みなおし」で検索をかけてみてください。

                        <br />
                        ＊座標の書き込み先がFCでもPTでも貼り付け可能です。CWLSでもいけるっぽい・・？まだデータ足らず。1~3インスタンスの表示はそのままで、かまいません。
                        <br />
                        ＊チャット欄のカスタマイズ状況によっては、名前に記号が入ってしまうなど確認しています。
                        <br />

                        ＊経路最適化には、数学的に最短経路（巡回セールスマン問題）を考えるアルゴリズムが入っていますが、考慮もれ等があるかもしれません。
                        <br />
                        ＊アルゴリズム的に経路や開始地点がいくつかあっても良い場合、チャットに貼ったテキストの順番によって経路が変わる可能性があります。
                      </span>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </p>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col>
                  <span>チャット入力欄</span>
                  <v-textarea
                    ref="datainput"
                    v-model="input_text"
                    style="
                      width: 450px;
                      border: 2px solid #000;
                      font-size: 0.9em;
                    "
                    rows="10"
                    placeholder="ここにテキストを貼ってください。"
                    label="貼り付けエリア"
                  ></v-textarea>
                  <div v-on:click="process">
                    <div>
                      <v-btn
                        depressed
                        color="primary"
                        width="350px"
                        class="mt-md-5 mx-l"
                      >
                        経路作成
                      </v-btn>
                    </div>
                    <p>{{ procesed_text }}</p>
                  </div>
                </v-col>
                <v-col style="white-space: pre-line">
                  <v-card width="500" class="ml-md-16 mx-l">
                    地図ルート

                    <v-btn
                      class="ma-2"
                      color="indigo"
                      dark
                      @click="copyToClipboard2('a')"
                    >
                      <v-icon>mdi-content-copy</v-icon>コピー
                    </v-btn>
                    <v-textarea
                      :value="this.fin_text"
                      rows="10"
                      style="white-space: pre-line; height: 350px"
                    >
                    </v-textarea>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card elevation="3" style="white-space: pre-line">
              <v-card-text style="white-space: pre-line">
                <v-btn
                  class="ma-2"
                  color="indigo"
                  dark
                  @click="copyToClipboard3('a')"
                >
                  <v-icon>mdi-content-copy</v-icon>コピー
                </v-btn>
                <span ref="startptmacro">
                  <v-textarea :value="this.startptmacro" rows="5"> </v-textarea>
                </span>
              </v-card-text>
              <div></div>
            </v-card>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-card-title class="text-h5">
              <p class="mybox">
                順路に沿って、左側の名前と場所が書いてあるボタンを押してください。
                <br />
                ボタンを押すと、右側のマップにて詳細な経路マップが描画されます。
                <br />
                このメッセージのすぐ下には、現在押しているボタンに該当するパーティーチャットが表示されます。次はだれ？を知らせるために、地図の処理が終わる->次の人のボタンを押す->コピーボタンをおす->チャットに貼る
                といった流れの使い方を想定しています。
              </p>
            </v-card-title>
            <div style="width: 300px"></div>
            <div>
              <v-card>
                <v-btn
                  class="ma-2"
                  color="indigo"
                  dark
                  @click="copyToClipboard4('a')"
                >
                  <v-icon>mdi-content-copy</v-icon>コピー
                </v-btn>
                <p ref="nowmacro">
                  {{ this.fin_text_arr[this.clicked_id] }}
                </p></v-card
              >
            </div>

            <v-card-text>
              <v-card-actions>
                <v-container>
                  <v-row>
                    <v-col dense class="mr-md-16">
                      <v-col v-for="sh in fin_arr" :key="sh['id']">
                        <v-card
                          v-if="Object.keys(sh).includes('earthlite') == true"
                          color="indigo lighten-4"
                          class="mb-md-3 mx-l"
                        >
                          テレポ：{{ sh["earthlite"] }}
                        </v-card>

                        <v-btn
                          height="50"
                          v-on:click="showmap(sh, 1)"
                          :class="clickColor(sh)"
                        >
                          <v-row>
                            <v-col>
                              {{ sh["id"] + 1 }}
                            </v-col>
                            <v-col>
                              {{ sh["name"] }}
                              <br />
                              {{ sh["place"] }}
                              <br />
                            </v-col>
                            <v-col>
                              |X:{{ sh["xpos"] }}
                              <br />
                              |Y:{{ sh["ypos"] }}
                            </v-col>
                          </v-row>
                        </v-btn>
                      </v-col>
                    </v-col>

                    <v-col>
                      <p style="font-size: 23px">
                        【{{ this.current_show["place"] }}】
                        <span>
                          <v-btn v-on:click="zoomin()"
                            >ターゲットをズーム</v-btn
                          >
                          <v-btn v-on:click="zoomout()">ズームをリセット</v-btn>
                        </span>
                      </p>
                      <div>
                        <l-map
                          ref="map"
                          :min-zoom="minZoom"
                          :crs="crs"
                          :center="center"
                          style="height: 500px; width: 500px"
                          :zoom="zoom"
                        >
                          <l-image-overlay :url="url" :bounds="bounds" />
                          <l-marker
                            v-for="star in stars"
                            :key="star.name"
                            :lat-lng="star"
                          >
                            <l-tooltip
                              :content="star.name"
                              :options="{
                                permanent: true,
                                interactive: true,
                                opacity: 0.7,
                              }"
                            >
                            </l-tooltip>
                          </l-marker>
                          <l-polyline :lat-lngs="travel" />
                        </l-map>
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <v-col>
      <v-card class="d-flex align-center justify-center pa-4 mx-auto" outlined>
        <div>
          v.0.2.0β:
          7.0対応。2024/7/1現在地図PTがいかんせん少ないので、要検証です。地図の位置ずれ問題はやりながら修正予定です。<br>
          v.0.1.0β:
          サイトを公開しました。まだまだ不安定なところあるはず。ぜひ、最初にテストしてからお使いください。何卒お手柔らかに・・・。
        </div>
      </v-card>
      <v-card class="d-flex align-center justify-center pa-4 mx-auto" outlined>
        <div>
          本サイトにおいて提供される情報の正確性に対する保証行為をしておりません。<br />
          また、各サービスを利用したことに起因する直接的又は間接的な損害に関して一切責任を負わないものとします。
          <br />

          ロドストの説明記事は
          <a
            href="https://jp.finalfantasyxiv.com/lodestone/character/1333693/blog/4924095/"
            >こちら</a
          >
          >
          <br />
          記載されている会社名・製品名・システム名などは、各社の商標、または登録商標です。
          <br />
          Copyright (C) 2010 - 2024 SQUARE ENIX CO., LTD. All Rights Reserved.
        </div>
      </v-card>
    </v-col>
  </v-container>
</template>

<script>
import file from "csv-loader!@/assets/teleportation60.csv";
import file2 from "csv-loader!@/assets/eartlite.csv";
import csvreader from "@/components/csvreader";
import location2tspdata from "@/components/location2tspdata";
import TSPSolver from "@nikbelikov/tsp-solver";
import { CRS } from "leaflet";
import { LMap, LImageOverlay, LMarker, LPolyline } from "vue2-leaflet";
import { Icon } from "leaflet";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default {
  name: "HelloWorld",
  components: {
    LMap,
    LImageOverlay,
    LMarker,
    LPolyline,
  },
  data: () => ({
    center: [512, 512],
    url: require("../assets/ラヴィリンソス.png"),
    bounds: [
      [0, -0],
      [1024, 1024],
    ],
    zoom: -2,
    minZoom: -1,
    crs: CRS.Simple,
    stars: [],
    travel: [],
    map_fontsize: {
      label: "マップ中の文字サイズ",
      val: 12,
      color: "red",
    },
    map_zoomsize: {
      label: "ズームレベル",
      val: 1,
      color: "blue",
    },
    counter: 0,
    procesed_text: "",
    input_text: "",
    worksheet: [],
    editmessage: "",
    teleportation_distance: [],
    teleportation_distance_sheet: [],
    teleportation_tsp: {},
    split_data: [],
    use_route: [],
    teleportation_result: [],
    use_route_points: [],
    use_route_values: [],
    default_teleportation_data: [],
    tsp_data: [],
    pos_tsp_data: [],
    pos_tsp_result: [],
    default_eartlite_data: [],
    fin: [],
    fin_text: "",
    fin_text_arr: [],
    canvas: null,
    context: null,
    show: [],
    fin_arr: [],
    clicked_id: 0,
    tabs: null,
    text: "",
    maptype: ["G17","G16", "G8", "G12", "G14", "隠された地図G1"],
    rottype: ["", "フリロ", "地図主NEED", "主催NEED"],
    mapowner: ["", "募集主持参", "1枚持ち寄り", "2枚持ち寄り", "3枚持ち寄り"],
    teleportowner: ["", "募集主", "マップ主"],
    use_maptype: "G17",
    use_rottype: "フリロ",
    use_mapowner: "1枚持ち寄り",
    use_checkbox: true,
    use_checkbox2: false,
    use_server: "Ridill",
    use_teleportowner: "募集主",
    current_show: [],
    startptmacro: "",
    sampletxt: "",
    sampleonetime: false,
    zoomstate: false,

    servers: [
"Adamantoise",
"Aegis",
"Alexander",
"Alpha",
"Anima",
"Asura",
"Atomos",
"Bahamut",
"Balmung",
"Behemoth",
"Belias",
"Bismarck",
"Brynhildr",
"Cactuar",
"Carbuncle",
"Cerberus",
"Chocobo",
"Coeurl",
"Cuchulainn",
"Diabolos",
"Durandal",
"Excalibur",
"Exodus",
"Faerie",
"Famfrit",
"Fenrir",
"Garuda",
"Gilgamesh",
"Goblin",
"Golem",
"Gungnir",
"Hades",
"Halicarnassus",
"Hyperion",
"Ifrit",
"Innocence",
"Ixion",
"Jenova",
"Kraken",
"Kujata",
"Lamia",
"Leviathan",
"Lich",
"Louisoix",
"Maduin",
"Malboro",
"Mandragora",
"Marilith",
"Masamune",
"Mateus",
"Midgardsormr",
"Moogle",
"Odin",
"Omega",
"Pandaemonium",
"Phantom",
"Phoenix",
"Pixie",
"Rafflesia",
"Ragnarok",
"Raiden",
"Ramuh",
"Ravana",
"Ridill",
"Sagittarius",
"Sargatanas",
"Sephirot",
"Seraph",
"Shinryu",
"Shiva",
"Siren",
"Sophia",
"Spriggan",
"Tiamat",
"Titan",
"Titania",
"Tonberry",
"Twintania",
"Tycoon",
"Typhon",
"Ultima",
"Unicorn",
"Valefor",
"Yojimbo",
"Zalera",
"Zeromus",
"Zodiark",
"Zurvan"
    ],
  }),
  mounted: function () {
    var { csvarray } = csvreader({
      //引数内でプロパティ名を指定してデータを渡す
      file: file,
    });
    this.default_teleportation_data = csvarray;

    csvarray = csvreader({
      //引数内でプロパティ名を指定してデータを渡す
      file: file2,
    });
    this.default_eartlite_data = csvarray["csvarray"];
    var { result } = location2tspdata({
      //引数内でプロパティ名を指定してデータを渡す
      csvarray: this.default_teleportation_data,
    });
    this.teleportation_tsp = result;
  },
  methods: {
    firstclickstep2() {
      setTimeout(() => {
        this.showmap(this.current_show, 1);
      }, 1000);
    },
    zoomin() {
      //var xpos = this.current_show["xpos"];
      //var ypos = this.current_show["ypos"];
      //ctx.moveTo(xpos, ypos);

      var size = 1024;

      this.$refs.map.mapObject.setView(
        {
          lat: size - (size * this.current_show["ypos"]) / 42,
          lng: (size * this.current_show["xpos"]) / 42,
        },
        3
      );
      this.zoomstate = true;

      //canvas.width = this.width;
      //canvas.height = this.height;
      //ctx.clearRect(0, 0, this.width, this.height);
      //ctx.save();
      //ctx.restore();
    },
    zoomout() {
      this.showmap(this.current_show, 1);

      this.zoomstate = false;
    },
    calc_distance(data) {
      var distance_sum = 0;

      for (var data_index = 0; data_index < data.length - 1; data_index++) {
        var forward_pos_x = data[data_index + 1]["xpos"];
        var forward_pos_y = data[data_index + 1]["ypos"];
        var current_pos_x = data[data_index]["xpos"];
        var current_pos_y = data[data_index]["ypos"];
        var distance1 = Math.sqrt(
          (current_pos_y - forward_pos_y) ** 2 +
            (current_pos_x - forward_pos_x) ** 2
        );
        distance_sum = distance_sum + distance1;
      }
      return distance_sum;
    },
    sampledatainput() {
      this.sampletxt = "[FC]<Xiv Chara1> ヘリテージファウンド ( 21.3  , 28.6 )";
      this.sampletxt =
        this.sampletxt + "\n(Xiv Chara2) ヘリテージファウンド (16.3 , 15.0 )";
      this.sampletxt =
        this.sampletxt + "\n[FC]<Xiv Chara3> ヤクテル樹海 ( 13.3 , 15.6 )";
      this.sampletxt =
        this.sampletxt + "\n(Xiv Chara4) オルコ・パチャ ( 18.9  , 6.3 )";
      this.sampletxt =
        this.sampletxt + "\n(Xiv Chara5) コザマル・カ ( 23.2  , 25.0 )";
      this.sampletxt =
        this.sampletxt + "\n[FC]<Xiv Chara6> オルコ・パチャ ( 25.3  , 21.6 )";

      this.sampleonetime = true;
      this.$refs.datainput.value = this.sampletxt;
      this.input_text = this.sampletxt;
    },

    change_map_fontsize(e) {
      this.map_fontsize.val = e;
      if (this.current_show != []) {
        if (this.zoomstate == true) {
          this.showmap(this.current_show, 2);
        } else {
          this.showmap(this.current_show, 1);
        }
      }
    },
    copyToClipboard1(text) {
      text;
      navigator.clipboard
        .writeText(this.$refs.message.textContent)
        .then(() => {
          console.log("copied!");
        })
        .catch((e) => {
          console.error(e);
        });
    },
    edit1() {
      this.editmessage = this.$refs.message.textContent;
    },
    copyToClipboard2(text) {
      text;
      navigator.clipboard
        .writeText(this.fin_text)
        .then(() => {
          console.log("copied!");
        })
        .catch((e) => {
          console.error(e);
        });
    },
    copyToClipboard3(text) {
      text;
      navigator.clipboard
        .writeText(this.startptmacro)
        .then(() => {
          console.log("copied!");
        })
        .catch((e) => {
          console.error(e);
        });
    },
    copyToClipboard4(text) {
      text;
      navigator.clipboard
        .writeText(this.$refs.nowmacro.textContent)
        .then(() => {
          console.log("copied!");
        })
        .catch((e) => {
          console.error(e);
        });
    },
    calc_most_close(use_start_point, use_earthlite) {
      var most_close = 100000;
      var most_close_idx = -1;
      var use_start_point_x_pos = use_start_point[2];
      var use_start_point_y_pos = use_start_point[3];

      for (
        var earthlite_idx = 0;
        earthlite_idx < use_earthlite.length;
        earthlite_idx++
      ) {
        var distance = Math.sqrt(
          (Number(use_earthlite[earthlite_idx][2]) -
            Number(use_start_point_x_pos)) **
            2 +
            (Number(use_earthlite[earthlite_idx][3]) -
              Number(use_start_point_y_pos)) **
              2
        );
        if (most_close > distance) {
          most_close = distance;
          most_close_idx = earthlite_idx;
        }
      }
      return [most_close, most_close_idx];
    },
    showmap(sh, zoom) {
      var size = 1024;
      this.clicked_id = sh["id"];
      this.current_show = sh;

      this.url = require("../assets/" + sh["place"] + ".png"); // 画像のURLを指定
      this.stars = [];
      this.travel = [];
      this.zoom = -1;
      zoom;
      this.$refs.map.mapObject.setZoom(-1);
      this.center = [512, 512];
      this.$refs.map.mapObject.setView({ lat: 512, lng: 512 }, -1);

      var all_sh = this.fin_arr.filter(function (value) {
        return value["place"] == sh["place"];
      });
      var earthlite_xpos = (size * all_sh[0]["earthlite_x"]) / 42;
      var earthlite_ypos = (size * all_sh[0]["earthlite_y"]) / 42;
      this.stars.push({
        name: all_sh[0]["earthlite"],
        lat: size - earthlite_ypos,
        lng: earthlite_xpos,
      });
      this.travel.push([size - earthlite_ypos, earthlite_xpos]);

      for (
        var draw_circle_idx = 0;
        draw_circle_idx < all_sh.length;
        draw_circle_idx++
      ) {
        var xpos = (size * all_sh[draw_circle_idx]["xpos"]) / 42;
        var ypos = (size * all_sh[draw_circle_idx]["ypos"]) / 42;
        this.stars.push({
          name: all_sh[draw_circle_idx]["name"],
          lat: size - ypos,
          lng: xpos,
        });
        this.travel.push([size - ypos, xpos]);
      }
    },
    clickColor(sh) {
      if (this.clicked_id == sh["id"]) {
        return "orange";
      } else {
        return "gray";
      }
    },
    convertCsvStringToArray(str) {
      var sp = String(str).split("\n");
      var data = [];
      for (var i = 0; i < sp.length; i++) {
        data.push(sp[i].split(","));
      }

      return sp;
    },

    process: function () {
      this.worksheet = [];
      this.split_data = [];
      this.use_route = [];
      this.teleportation_result = [];
      this.use_route_points = [];
      this.use_route_values = [];
      this.tsp_data = [];
      this.pos_tsp_data = [];
      this.pos_tsp_result = [];
      this.fin = [];
      this.fin_text = "";
      this.fin_text_arr = [];
      this.show = [];
      this.fin_arr = [];
      this.clicked_id = 0;
      //var us = require('underscore.string');
      var array_input_text;

      array_input_text = this.input_text.split(/\r\n|\n/);
      array_input_text.sort();
      //array_input_text = this.sampletxt.split(/\r\n|\n/);

      for (var i = 0; i < array_input_text.length; i++) {
        var text = array_input_text[i];
        if (text.indexOf("(") == 0 && text.indexOf("[") == 0) {
          text = "(" + text;
        }
        if (text.indexOf("(") == 0) {
          text = "<" + text.substring(1, text.length);
          text =
            text.substring(0, text.indexOf(")")) +
            ">" +
            text.substring(text.indexOf(")") + 1, text.length);
          text = "[PT]" + text;
        }
        text = text.replaceAll("", "");
        text = text.replaceAll("", "");
        text = text.replaceAll("'", "");
        text = text.replaceAll("□", "");
        var other_erase_txt = "";
        for (var text_idx = 0; text_idx < other_erase_txt.length; text_idx++) {
          text = text.replaceAll(other_erase_txt[text_idx], "");
        }

        for (
          var servername_idx = 0;
          servername_idx < this.servers.length;
          servername_idx++
        ) {
          if (text.lastIndexOf(this.servers[servername_idx]) > -1) {
            var start = text.lastIndexOf(this.servers[servername_idx]);
            var end =
              text.lastIndexOf(this.servers[servername_idx]) +
              this.servers[servername_idx].length;
            text = text.substring(0, start) + text.substring(end, text.length);
          }
        }
        var chat_group_start_pos = text.indexOf("[") + 1;
        var chat_group_end_pos = text.indexOf("]");

        var chat_group = text.substring(
          chat_group_start_pos,
          chat_group_end_pos
        );

        var chat_name_start_pos = text.indexOf("<") + 1;
        var chat_name_end_pos = text.indexOf(">");
        var chat_name = text.substring(chat_name_start_pos, chat_name_end_pos);

        var chat_place_start_pos = chat_name_end_pos + 3;
        var chat_place_end_pos = text.indexOf("(") - 1;
        var chat_place = text.substring(
          chat_place_start_pos,
          chat_place_end_pos
        );
        chat_place = chat_place.replace("", "");
        chat_place = chat_place.replace("", "");
        chat_place = chat_place.replace("", "");

        var chat_xpos_start_pos = text.indexOf("(") + 2;
        var chat_xpos_end_pos = text.indexOf(",") - 2;
        var chat_xpos = text.substring(chat_xpos_start_pos, chat_xpos_end_pos);

        var chat_ypos_start_pos = text.indexOf(",") + 2;
        var chat_ypos_end_pos = text.indexOf(")") - 1;
        var chat_ypos = text.substring(chat_ypos_start_pos, chat_ypos_end_pos);

        this.procesed_text;

        var user_data = {
          group: chat_group,
          name: chat_name,
          place: chat_place,
          xpos: chat_xpos,
          ypos: chat_ypos,
        };
        if (
          this.use_route.indexOf(chat_place) < 0 ||
          this.use_route.length == 0
        ) {
          this.use_route.push(chat_place);
        }

        this.worksheet.push(user_data);
      }

      //START

      for (
        var route_idx = 0;
        route_idx < this.teleportation_tsp["points"].length;
        route_idx++
      ) {
        if (
          this.use_route.indexOf(
            this.teleportation_tsp["points"][route_idx]["name"]
          ) > -1
        ) {
          this.use_route_points.push(
            this.teleportation_tsp["points"][route_idx]
          );

          this.use_route_points[this.use_route_points.length - 1]["id"] =
            this.use_route_points.length - 1;
        }
      }
      for (
        route_idx = 0;
        route_idx < this.teleportation_tsp["values"].length;
        route_idx++
      ) {
        var fromidx = this.use_route.indexOf(
          this.teleportation_tsp["values"][route_idx]["from"]
        );
        var toidx = this.use_route.indexOf(
          this.teleportation_tsp["values"][route_idx]["to"]
        );
        if (fromidx > -1 && toidx > -1) {
          this.use_route_values.push(
            this.teleportation_tsp["values"][route_idx]
          );
          this.use_route_values[this.use_route_values.length - 1]["set"][0] =
            this.use_route.indexOf(
              this.teleportation_tsp["values"][route_idx]["from"]
            );
          this.use_route_values[this.use_route_values.length - 1]["set"][1] =
            this.use_route.indexOf(
              this.teleportation_tsp["values"][route_idx]["to"]
            );
        }
      }

      //set id again

      this.teleportation_result = TSPSolver(
        this.use_route_points,
        this.use_route_values
      );

      for (
        var place_idx = 0;
        place_idx < this.teleportation_result["result"].length;
        place_idx++
      ) {
        var use_place = this.teleportation_result["result"][place_idx]["name"];

        var use_text = this.worksheet.filter(function (value) {
          return value["place"] == use_place;
        });

        this.tsp_data = [["CODE", "JP_CODE", "XPOS", "YPOS"]];
        for (var u = 0; u < use_text.length; u++) {
          var tmp = [];
          tmp.push(use_text[u]["name"]);
          tmp.push(use_text[u]["place"]);
          tmp.push(use_text[u]["xpos"]);
          tmp.push(use_text[u]["ypos"]);
          this.tsp_data.push(tmp);
        }

        //earth_lite point add

        //closet earthlite
        var use_earthlite = this.default_eartlite_data.filter(function (value) {
          return value[1] == use_place;
        });
        var mostclose_earthlite_distance = 1000000;
        var mostclose_earthlite_idx = -1;
        //var mostclose_treasure_idx = -1;

        for (
          var start_point_idx = 1;
          start_point_idx < this.tsp_data.length;
          start_point_idx++
        ) {
          var use_start_point = this.tsp_data[start_point_idx];
          var earthlite_distance = this.calc_most_close(
            use_start_point,
            use_earthlite
          );

          if (mostclose_earthlite_distance > earthlite_distance[0]) {
            mostclose_earthlite_idx = earthlite_distance[1];
            //mostclose_treasure_idx = start_point_idx - 1;
            mostclose_earthlite_distance = earthlite_distance[0];
          }
        }
        //generate earthlite point
        this.tsp_data.push([
          "earthlite",
          use_place,
          use_earthlite[mostclose_earthlite_idx][2],
          use_earthlite[mostclose_earthlite_idx][3],
        ]);

        var tsp_most_long_distance = 0;
        var tsp_most_long_distance_idx = 0;

        for (
          var tsp_index = 0;
          tsp_index < this.tsp_data.length - 1;
          tsp_index++
        ) {
          var forward_x = this.tsp_data[tsp_index][2];
          var forward_y = this.tsp_data[tsp_index][3];
          var earthlite_x = this.tsp_data[this.tsp_data.length - 1][2];
          var earthlite_y = this.tsp_data[this.tsp_data.length - 1][3];
          var distance = Math.sqrt(
            (forward_x - earthlite_x) ** 2 + (forward_y - earthlite_y) ** 2
          );
          if (distance > tsp_most_long_distance) {
            tsp_most_long_distance = distance;
            tsp_most_long_distance_idx = tsp_index;
          }
        }
        [this.tsp_data[1], this.tsp_data[tsp_most_long_distance_idx]] = [
          this.tsp_data[tsp_most_long_distance_idx],
          this.tsp_data[1],
        ];
        var { result } = location2tspdata({
          //引数内でプロパティ名を指定してデータを渡す
          csvarray: this.tsp_data,
        });

        this.pos_tsp_data = result;
        this.pos_tsp_result = TSPSolver(
          this.pos_tsp_data["points"],
          this.pos_tsp_data["values"],
          {
            finishId: this.pos_tsp_data["points"].length - 1,
            populationAmount: 100,
          }
        );

        var order = [];
        for (
          var order_idx = 0;
          order_idx < this.pos_tsp_result["result"].length;
          order_idx++
        ) {
          if (order_idx == this.pos_tsp_result["result"].length - 1) {
            order[order.length - 1]["earthlite"] =
              use_earthlite[mostclose_earthlite_idx][4];
            order[order.length - 1]["earthlite_x"] =
              use_earthlite[mostclose_earthlite_idx][2];
            order[order.length - 1]["earthlite_y"] =
              use_earthlite[mostclose_earthlite_idx][3];
          } else {
            var order_dict = {};
            order_dict["name"] =
              this.tsp_data[
                this.pos_tsp_result["result"][order_idx]["id"] + 1
              ][0];
            order_dict["place"] =
              this.tsp_data[
                this.pos_tsp_result["result"][order_idx]["id"] + 1
              ][1];
            order_dict["xpos"] =
              this.tsp_data[
                this.pos_tsp_result["result"][order_idx]["id"] + 1
              ][2];
            order_dict["ypos"] =
              this.tsp_data[
                this.pos_tsp_result["result"][order_idx]["id"] + 1
              ][3];
            order.push(order_dict);
          }
        }
        order = order.reverse();
        //this.fin_arr = order;

        for (var res = 0; res < order.length; res++) {
          this.show = order[res];
          var rtext =
            "/p " +
            this.show["name"] +
            " " +
            this.show["place"] +
            " (" +
            this.show["xpos"] +
            "," +
            this.show["ypos"] +
            ")";
          if (res == 0) {
            rtext =
              rtext +
              " " +
              use_earthlite[mostclose_earthlite_idx][4] +
              "にテレポ";
          }

          this.fin.push(rtext);
          this.show["id"] = this.fin_arr.length;
          this.fin_arr.push(this.show);
        }
      }

      for (var t = 0; t < this.fin.length; t++) {
        if (t == 0) {
          this.fin_text = this.fin[t];
        } else {
          this.fin_text = this.fin_text + "\n" + this.fin[t];
        }
        this.fin_text_arr.push(this.fin[t].substring(3, this.fin[t].length));
      }
      this.startptmacro =
        "/p 【開催地】:" +
        this.use_server +
        "/開始場所:" +
        this.fin_arr[0]["earthlite"] +
        "(インスタンスがあれば1)" +
        "\n/p PT解散後、開始場所にて現地集合します。" +
        "\n/p 再集合用のワールド内PTに入ってください。" +
        "\n/p 【テレポ】" +
        this.use_teleportowner +
        "\n/p 【ロット】" +
        this.use_rottype;
      this.current_show = this.fin_arr[0];
    },
  },
};
</script>
